import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _sortBy from "lodash/sortBy";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var fetchAllResources = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", client.get("/content/entries/resource", options).then(function (res) {
              var transformedResponse = res.map(function (resource) {
                var _resource$image, _resource$image2, _resource$image3, _resource$image3$fiel, _resource$image4, _resource$image4$fiel, _resource$resourceSin, _resource$resourceSin2, _resource$resourceSin3, _resource$resourceSin4, _resource$resourceSin5, _resource$resourceSin6, _resource$resourceSin7, _resource$resourceSin8, _resource$resourceSin9, _resource$resourceSin10, _resource$resourceSin11, _resource$resourceSin12, _resource$resourceSin13, _resource$resourceSin14, _resource$resourceSin15, _resource$resourceSin16, _resource$resourceSin17, _resource$resourceSin18, _resource$resourceSin19, _resource$resourceSin20, _resource$resourceSin21;

                return _objectSpread(_objectSpread({}, resource), {}, {
                  image: {
                    src: (_resource$image = resource.image) === null || _resource$image === void 0 ? void 0 : _resource$image.fields.file.url,
                    title: (_resource$image2 = resource.image) === null || _resource$image2 === void 0 ? void 0 : _resource$image2.fields.title,
                    width: (_resource$image3 = resource.image) === null || _resource$image3 === void 0 ? void 0 : (_resource$image3$fiel = _resource$image3.fields.file.details.image) === null || _resource$image3$fiel === void 0 ? void 0 : _resource$image3$fiel.width,
                    height: (_resource$image4 = resource.image) === null || _resource$image4 === void 0 ? void 0 : (_resource$image4$fiel = _resource$image4.fields.file.details.image) === null || _resource$image4$fiel === void 0 ? void 0 : _resource$image4$fiel.height
                  },
                  resourceSingle: _objectSpread(_objectSpread({}, (_resource$resourceSin = resource.resourceSingle) === null || _resource$resourceSin === void 0 ? void 0 : _resource$resourceSin.fields), {}, {
                    socialImage: {
                      src: (_resource$resourceSin2 = resource.resourceSingle) === null || _resource$resourceSin2 === void 0 ? void 0 : _resource$resourceSin2.fields.socialImage.fields.file.url,
                      title: (_resource$resourceSin3 = resource.resourceSingle) === null || _resource$resourceSin3 === void 0 ? void 0 : _resource$resourceSin3.fields.socialImage.fields.title,
                      width: (_resource$resourceSin4 = resource.resourceSingle) === null || _resource$resourceSin4 === void 0 ? void 0 : (_resource$resourceSin5 = _resource$resourceSin4.fields.socialImage.fields.file.details.image) === null || _resource$resourceSin5 === void 0 ? void 0 : _resource$resourceSin5.width,
                      height: (_resource$resourceSin6 = resource.resourceSingle) === null || _resource$resourceSin6 === void 0 ? void 0 : (_resource$resourceSin7 = _resource$resourceSin6.fields.socialImage.fields.file.details.image) === null || _resource$resourceSin7 === void 0 ? void 0 : _resource$resourceSin7.height
                    },
                    resourcePromo: _objectSpread(_objectSpread({}, (_resource$resourceSin8 = resource.resourceSingle) === null || _resource$resourceSin8 === void 0 ? void 0 : (_resource$resourceSin9 = _resource$resourceSin8.fields.resourcePromo) === null || _resource$resourceSin9 === void 0 ? void 0 : _resource$resourceSin9.fields), {}, {
                      image: {
                        src: (_resource$resourceSin10 = resource.resourceSingle) === null || _resource$resourceSin10 === void 0 ? void 0 : (_resource$resourceSin11 = _resource$resourceSin10.fields.resourcePromo) === null || _resource$resourceSin11 === void 0 ? void 0 : _resource$resourceSin11.fields.image.fields.file.url,
                        title: (_resource$resourceSin12 = resource.resourceSingle) === null || _resource$resourceSin12 === void 0 ? void 0 : (_resource$resourceSin13 = _resource$resourceSin12.fields.resourcePromo) === null || _resource$resourceSin13 === void 0 ? void 0 : _resource$resourceSin13.fields.image.fields.title,
                        width: (_resource$resourceSin14 = resource.resourceSingle) === null || _resource$resourceSin14 === void 0 ? void 0 : (_resource$resourceSin15 = _resource$resourceSin14.fields.resourcePromo) === null || _resource$resourceSin15 === void 0 ? void 0 : (_resource$resourceSin16 = _resource$resourceSin15.fields.image.fields.file.details.image) === null || _resource$resourceSin16 === void 0 ? void 0 : _resource$resourceSin16.width,
                        height: (_resource$resourceSin17 = resource.resourceSingle) === null || _resource$resourceSin17 === void 0 ? void 0 : (_resource$resourceSin18 = _resource$resourceSin17.fields.resourcePromo) === null || _resource$resourceSin18 === void 0 ? void 0 : (_resource$resourceSin19 = _resource$resourceSin18.fields.image.fields.file.details.image) === null || _resource$resourceSin19 === void 0 ? void 0 : _resource$resourceSin19.height
                      }
                    }),
                    faqs: (_resource$resourceSin20 = resource.resourceSingle) === null || _resource$resourceSin20 === void 0 ? void 0 : (_resource$resourceSin21 = _resource$resourceSin20.fields.faqs) === null || _resource$resourceSin21 === void 0 ? void 0 : _resource$resourceSin21.map(function (_ref2) {
                      var fields = _ref2.fields;
                      return fields;
                    })
                  })
                });
              });
              return _sortBy(transformedResponse, ["title"]);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllResources(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchFeaturedResources = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var client, _ref3$max, max, options, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _ref3.client, _ref3$max = _ref3.max, max = _ref3$max === void 0 ? 3 : _ref3$max, options = _ref3.options;
            _context2.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context2.sent.filter(function (item) {
              return item.featured;
            }).slice(0, max);
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchFeaturedResources(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
export var fetchResource = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var client, options, url, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref5.client, options = _ref5.options, url = _ref5.url;
            _context3.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context3.sent.find(function (item) {
              return item.url === url;
            });
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchResource(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
export var fetchSingleResource = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var client, options, url, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            client = _ref7.client, options = _ref7.options, url = _ref7.url;
            _context4.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context4.sent.find(function (item) {
              var _item$resourceSingle;

              return ((_item$resourceSingle = item.resourceSingle) === null || _item$resourceSingle === void 0 ? void 0 : _item$resourceSingle.url) === url;
            });
            return _context4.abrupt("return", data === null || data === void 0 ? void 0 : data.resourceSingle);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchSingleResource(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
export var fetchFilters = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var client, filtersObjs, options, allResources, filters;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = _ref9.client, filtersObjs = _ref9.filtersObjs, options = _ref9.options;
            _context5.next = 3;
            return fetchAllResources(client, options);

          case 3:
            allResources = _context5.sent;
            filters = filtersObjs.map(function (_ref11) {
              var id = _ref11.id,
                  displayName = _ref11.displayName,
                  searchableId = _ref11.searchableId;
              var options = allResources.reduce(function (acc, resource) {
                if (resource[id]) {
                  var value = resource[id];
                  if (typeof value === "string") acc.push(value);else if (Array.isArray(value)) acc.push.apply(acc, _toConsumableArray(value));else {
                    throw new Error("Unexpected value type for filter ".concat(id));
                  }
                }

                return acc;
              }, []);
              return {
                id: id,
                searchableId: searchableId,
                displayName: displayName,
                options: _sortBy(Array.from(new Set(options)).map(function (option) {
                  return {
                    value: option,
                    text: option
                  };
                }), function (opt) {
                  return opt.value.toLowerCase();
                })
              };
            });
            return _context5.abrupt("return", filters);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchFilters(_x6) {
    return _ref10.apply(this, arguments);
  };
}();